import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { SessionCourseCollegeModelPopComponent } from '../session-course-college-model-pop/session-course-college-model-pop.component';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-session-course-college',
  templateUrl: './session-course-college.component.html',
  styleUrls: ['./session-course-college.component.scss']
})
export class SessionCourseCollegeComponent implements OnInit {
  SessionCoClgList: any[];
  setIntervalSearch: any;
  constructor(public umsService: UmsService, private spinner: NgxSpinnerService,
    private dialog: MatDialog,private fb: FormBuilder,) { }
  SessionCoClgSearchForm: FormGroup;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage = 1;
  totalItems = 0;
  userPermission: any;
  UserCollege
  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.fetchlistOfSessCoColg();
    this.SessionCoClgSearchForm = this.fb.group({
      SearchString: new FormControl (''),
    });
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    const newPageIndex = event.pageIndex + 1;
    this.currentPage = newPageIndex;
    this.fetchlistOfSessCoColg();
    this.keypress1();
  }

  fetchlistOfSessCoColg() {
    this.spinner.show();
    if(this.userPermission[0].CgUi == 'C'){
      this.UserCollege= this.userPermission[0].CgId;
    }
    else{
      this.UserCollege = ''
    }
    const payload = {};
    payload['CgCode'] = this.UserCollege;
    payload['PageSize'] = this.pageSize;
    payload['PageNumber'] = this.currentPage;
    this.umsService.searchSessCoColg(payload).subscribe(res => {
      this.spinner.hide();
      this.SessionCoClgList = res.data;
      this.totalItems = res.data[0].TotalRecords;
      
    }, (ERROR: HttpErrorResponse) => {
      this.SessionCoClgList = [];
      this.spinner.hide();
    });
  }

  keypress1() {
    if(this.setIntervalSearch){
      clearTimeout(this.setIntervalSearch);
    }
    this.setIntervalSearch = setTimeout(()=>{
      let payload = {};
    payload['PageSize'] = this.pageSize;
    // payload['PageNumber'] = this.currentPage;
    payload['SearchString'] = this.SessionCoClgSearchForm.value['SearchString'];
    if (payload['SearchString'] === "") {
      payload['PageNumber'] = this.currentPage;
    } else {
      payload['PageNumber'] = 1;
    }
    this.umsService.searchSessCoColg(payload).subscribe(res => {
      if(res.status){
        this.SessionCoClgList = [];
        this.SessionCoClgList = res.data;
        this.totalItems = res.data[0].TotalRecords;
      }
      else{
        this.SessionCoClgList = [];
        this.totalItems = 0;
      }
     
      // this.SessionCoClgList = res.data;
    }, (ERROR: HttpErrorResponse) => {
      this.SessionCoClgList = [];
    });
    },1000)
   
  }

  addnewrecord() {
    const dialogRef = this.dialog.open(SessionCourseCollegeModelPopComponent, {
      width: '110vh',
      data: { key: "New" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data here
      this.fetchlistOfSessCoColg();
      this.SessionCoClgSearchForm.controls['SearchString'].setValue('');
    });
  }

  editData(k) {
    const dialogRef = this.dialog.open(SessionCourseCollegeModelPopComponent, {
      width: '110vh',
      data: { selected: k, key: "Edit" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data 
      this.fetchlistOfSessCoColg();
      this.SessionCoClgSearchForm.controls['SearchString'].setValue('');
    });
  }

}
